import type { JSX } from 'react'
import { TopPageNotification as TopPageNotificationArcana } from '@setplex/arcana'
import { useUnit } from 'effector-react'
import { featuresNewDomainNotificationModel } from '~/features/new-domain-notification'
import { Trans } from 'react-i18next'
import { model as i18n } from '!/i18n'

export function TopPageNotification(): JSX.Element | null {
  const showNotification = useUnit(
    featuresNewDomainNotificationModel.$showNotification
  )
  const hideNotification = useUnit(
    featuresNewDomainNotificationModel.hideNotification
  )
  const { t } = useUnit(i18n.$t)

  const link = window.location.host

  if (!showNotification) return null

  return (
    <TopPageNotificationArcana onClose={hideNotification}>
      <Trans
        t={t}
        i18nKey='moved_message'
        components={{
          1: (
            <a
              href={`https://${link}`}
              rel='noreferrer'
              style={{ textDecoration: 'underline' }}
            />
          ),
        }}
        values={{
          new_domain: link,
        }}
      />
    </TopPageNotificationArcana>
  )
}
